import { render, staticRenderFns } from "./peopleDemand.vue?vue&type=template&id=94301a5a&scoped=true"
import script from "./peopleDemand.vue?vue&type=script&lang=js"
export * from "./peopleDemand.vue?vue&type=script&lang=js"
import style0 from "./../style.scss?vue&type=style&index=0&id=94301a5a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94301a5a",
  null
  
)

export default component.exports